export default __webpack_public_path__ + "static/media/ltr.18a645ca.svg";